import { PublicationListTotalData } from "@interface/publicationList.interface";

export const adaptPublicationListData = (
  responseData: PublicationListTotalData,
) => {
  return {
    ...responseData,
    data: responseData.data.map((info) => {
      return {
        ...info,
        organizationName: info.organizationName || [],
      };
    }),
  };
};
